
angular.module('mtic.components.login')
.component('mticPostIamRegistrationSchoolOne', {
  templateUrl: 'template.html',
  bindings: {
    id: '<',
    nameSlug: '<',
    nameLong: '<',
    // infos: '<',
    select: '<',
    isSelected: '<'
  },
  controllerAs: 'school',
  controller($log) {
    const school = this;

    // $log.log('school info pass', school.nameSlug, school.nameLong)

    school.iconClass = () => {
      if(school.isSelected(school)) {
        return {
          'button': true,
          'is-info': true,
        }
      }else{
        return {
          'button': true,
          'is-info': true,
          'is-outlined': true,
        }
      }
    }
  }
})
